import PageHero from "@/components/feature/PageHero";
import Process from "./components/Process";
import Test from "./components/Test";
import ConsultCTA from "@/pages/home/components/ConsultCTA";

export default function Admission() {
  return (
    <>
      <PageHero
        tag="ADMISSION"
        title={
          <>
            이름값 하는 수학의
            <br />
            <span className="text-primary-500">입학을 안내합니다</span>
          </>
        }
        description="상담부터 입학테스트, 반 배정까지. 학생의 현재 실력을 정확히 진단해 가장 적합한 반을 설계해 드립니다."
        image="https://readdy.ai/api/search-image?query=Abstract%20stylized%20dark%20composition%20with%20flowing%20glowing%20lime%20green%20mathematical%20curves%20and%20geometric%20grid%20patterns%20over%20a%20deep%20charcoal%20background%2C%20soft%20volumetric%20light%2C%20minimal%20editorial%20poster%20art%2C%20cinematic%20depth%2C%20no%20text&width=1920&height=720&seq=mbhj-admission-hero-01&orientation=landscape"
      />
      <Process />
      <Test />
      <ConsultCTA />
    </>
  );
}